import React, { useState, useEffect, useContext } from 'react';
import AuthContext from '../../context/userAuth.context';
import axios from 'axios';
import DoneIcon from '@mui/icons-material/Done';
import Button from '@mui/material/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function MyPurchases() {

    const { authenticationData,UserData, Access } = useContext(AuthContext);
    useEffect(() => {
        getMyPurchases();
    }, []);
    let authData = JSON.parse(localStorage.getItem("animation_studio_2.0_access_token"));
    const getMyPurchases = () => {
             
        var formdata = new FormData();
        formdata.append("email", UserData.email);
        axios.post(authenticationData.ApiBaseURL + "/api/Account/getMyPurchases",
            formdata,
            {
                headers: {
                    "Content-Type": `multipart/form-data`,
                    "Access-Control-Allow-Origin": "*",
                    Authorization: "Bearer " + authData.access_token,
                },
            }
        ).then((response) => {
            var res= removeObjectsWithMatchingProperties(response.data.allproducts,response.data.assignedProducts,"fid")
            const uniquePfids = new Set();
            // Filter the array to get unique objects based on pfid
            const uniqueAssignedObjs = response.data.assignedProducts.filter((obj) => {
                if (!uniquePfids.has(obj.pfid)) {
                    uniquePfids.add(obj.pfid);
                    return true;
                }
                return false;
            });
            setPurchasedItems(uniqueAssignedObjs);           
            setAllItems(res);
        });
    }

    function removeObjectsWithMatchingProperties(array1, array2, propertyName) {
        return array1.filter(item1 => !array2.some(item2 => item2[propertyName] === item1[propertyName]));
    }


    const [purchasedItems, setPurchasedItems] = useState([
        // { id: 1, name: 'Item 1', price: 10.99 },
        // { id: 2, name: 'Item 2', price: 24.99 },
        // { id: 3, name: 'Item 3', price: 7.49 },
        // // Add more items as needed
    ]);

    const [allItems, setAllItems] = useState([
        // { id: 1, name: 'Item 1', price: 10.99 },
        // { id: 2, name: 'Item 2', price: 24.99 },
        // { id: 3, name: 'Item 3', price: 7.49 },
        // // Add more items as needed
    ]);

    const visitPage=(buynow)=>{
        window.open(buynow, '_blank', 'noopener,noreferrer');
    }
    

    const itemStyle = {
        border: '1px solid #ccc',
        borderRadius: '5px',
        padding: '10px',
        marginBottom: '10px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: '#f7f7f7',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    };

    const listStyle = {
        listStyle: 'none',
        padding: '0',

    };
    return (
        <div style={{display:'flex',justifyContent:'center'}}>

        <div className="purchased-items-container" style={{maxWidth:"600px",width:'100%'}}>
            <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>Your Purchased Items</h2>
            <ul style={listStyle}>
                {purchasedItems.map(item => (
                    <li key={item.id} style={itemStyle}>
                        <span>{item.productFunnelName}</span>
                        <a href={`${item.accessLink}`} target='_blank'>Access</a> 
                    </li>
                ))}
                 {allItems.map(item => (                    
                    <li key={item.id} style={itemStyle}>
                        <span>{item.productFunnelName}</span>
                        {Access === 'US5' ? <a href={`${item.accessLink}`} target='_blank'>Access</a>:<Button variant="contained"  onClick={()=>visitPage(item.salesPagelink)} size='large'>
                        Upgrade
                        </Button>}
                        {/* <button className='btn-primary'></button> */}
                    </li>
                ))}
            </ul>
        </div>
        </div>
    );
}

export default MyPurchases